import React, { Component } from 'react'
import { connect } from 'react-redux'

import * as R from 'ramda'

import dataActions from 'actions/dataActions'
import { doc, dirtyRead } from 'selectors/common'
import Section from 'components/Section'
import StartDatePicker from './StartDatePicker'
import DueDatePicker from './DueDatePicker'


let select = dirtyRead(
	(state, props) => ({
		task: doc(state, props.objectID)
	})
)

export class Dates extends Component{
	render(){
		let { props } = this
		return(
			<Section
				id="task/dates"
				title="Dates"
			>
				<StartDatePicker objectID={props.objectID} />
				<DueDatePicker objectID={props.objectID} />
            </Section>
		)
	}
}

export default connect(select, dataActions)(Dates)



// WEBPACK FOOTER //
// ./src/routes/landlord/taskForm/Dates.js